import { SERVICES } from "../../configs/constants";

export default {
	display: true,
	title: "Base PDC",
	contentType: "menu",
	canReduce: true,
	search: false,
	content: [
		{
			label: "Points de contact",
			icon: "buildings",
			id: "basepdc",
			component: "",
			path: "/metier/sectors",
			onClick: "",
			service:SERVICES.Secto,
			submenu: [
				{
					id: "sectors",
					label: "Secteurs",
					active: false,
					path: "/metier/sectors",
				}/*,
				{
					id: "pdcs",
					label: "Points de contact",
					active: false,
					path: "/metier/pdcs",
				},*/
			],
		},
		/*{
			label: "Questionnaire",
			icon: "survey",
			id: "questionnaire",
			component: "",
			path: "/survey",
			onClick: "",
			submenu: [
				{
					id: "surveyList",
					label: "Liste des questionnaires",
					active: false,
					path: "/survey",
				},
				{
					id: "surveyCreate",
					label: "Créer un questionnaire",
					active: false,
					path: "/survey/creation",
				},
			],
		},*/
	],
};



// WEBPACK FOOTER //
// src/pages/metier/Menu.js